import { transformStringField } from '../../../utils';
import MultiLinesWrapper from '../../MultiLinesWrapper.vue';
export default {
    name: 'StringRender',
    components: {
        MultiLinesWrapper,
    },
    props: {
        field: {
            type: Object,
            required: true,
        },
        value: {
            type: String,
            default: null,
        },
    },
    computed: {
        formattedValue() {
            return transformStringField(this.value);
        },
    },
};
